











import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class PeriodComparator extends Vue {
  @Prop({ default: 0, required: true }) currentValue!: number;
  @Prop() previousValue?: number;

  get color(): string {
    if (this.previousValue == undefined || this.difference == 0) {
      return "tw-text-gray-400";
    } else if (this.isPositive) {
      return "tw-text-green-400";
    } else {
      return "tw-text-red-400";
    }
  }

  get isPositive(): boolean | null {
    if (this.previousValue != undefined) {
      return this.currentValue > this.previousValue;
    } else {
      return null;
    }
  }

  get difference(): number | null {
    if (this.previousValue != undefined) {
      return this.currentValue - this.previousValue;
    } else {
      return null;
    }
  }
}
